module.exports = __webpack_public_path__ + "media/sketchscope_basic.055f3c2b.mp4";